const MS_TO_KMPH = 3.6;
const MS_TO_MPH = 2.23694;

/**
 * Clamp a meters-per-second value so it is never negative.
 * GPS hardware occasionally reports small negative speeds which are
 * physically meaningless — this normalises them to zero.
 */
export function clampSpeed(metersPerSecond: number): number {
  return Math.max(0, metersPerSecond);
}

export function formatSpeed(metersPerSecond: number, isMetric: boolean): string {
  const converted = clampSpeed(metersPerSecond) * (isMetric ? MS_TO_KMPH : MS_TO_MPH);
  const unit = isMetric ? 'km/h' : 'mph';
  return `${converted.toFixed(1)} ${unit}`;
}

export function formatSpeedRounded(metersPerSecond: number, isMetric: boolean): string {
  const converted = clampSpeed(metersPerSecond) * (isMetric ? MS_TO_KMPH : MS_TO_MPH);
  const unit = isMetric ? 'km/h' : 'mph';
  return `${converted.toFixed(0)} ${unit}`;
}
